import { setAuthToken, API_BASE } from './apiClient';
import authService from './authService';
import contentService from './contentService';
import audioService from './audioService';
import healthService from './healthService';
import adminService from './adminService';

export {
  authService as authApi,
  contentService as contentApi,
  audioService as audioApi,
  healthService as healthApi,
  adminService as adminApi,
  setAuthToken,
  API_BASE,
  contentService
};

export const downloadGenerationZip = contentService.downloadGenerationZip;

// Legacy compatibility export
export default {
  auth: authService,
  content: contentService,
  audio: audioService,
  health: healthService,
  admin: adminService,
  setAuthToken,
  downloadGenerationZip: contentService.downloadGenerationZip,
  API_BASE,
};
